import React from 'react'
import ReactPlayer from "react-player";

function YoutubeVideo() {
    return (
        <div>
            <br />
            <div className="album py-1">
                <div className="container">
                    <div className="row">
                        <div className="col-md-4 mt-2">
                            <div className="bestclothshowroominbethuadahari">
                                <ReactPlayer width="100%" height="100%" url="https://www.youtube.com/watch?v=mGYxV-Lpi6A&t=252s" />
                            </div>
                        </div>
                        <div className="col-md-4 mt-2">
                            <div className="bestclothshowroominbethuadahari">
                                <ReactPlayer width="100%" height="100%" url="https://www.youtube.com/watch?v=KsNzSLb16_4" />
                            </div>
                        </div>
                        <div className="col-md-4 mt-2">
                            <div className="bestclothshowroominbethuadahari">
                                <ReactPlayer width="100%" height="100%" url="https://www.youtube.com/watch?v=oHqADTAbx4Y" />
                            </div>
                        </div>

                        <div className="col-md-4 mt-2">
                            <div className="bestclothshowroominbethuadahari">
                                <ReactPlayer width="100%" height="100%" url="https://www.youtube.com/watch?v=tklv6-1swf4"/>
                            </div>
                        </div>

                        <div className="col-md-4 mt-2">
                            <div className="bestclothshowroominbethuadahari">
                                <ReactPlayer width="100%" height="100%" url="https://www.youtube.com/watch?v=d52YAngB74Y"/>
                            </div>
                        </div>
                        

                        <div className="col-md-4 mt-2">
                            <div className="bestclothshowroominbethuadahari">
                                <ReactPlayer width="100%" height="100%" url="https://www.youtube.com/watch?v=dr_MmvJOzkM"/>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <br />

        </div>
    )
}

export default YoutubeVideo